import {observer} from 'mobx-react';
import React from 'react';

import {buildWordpressUrl} from '../../../../../utils/routeHelper';
import mainConfig from '../../../../../config/main';
import darkblueLogo from '../../../../../assets/images/horizontal-darkblue.png';
import darkblueLogoStaging from '../../../../../assets/images/horizontal-darkblue-staging.png';

import './logoNavItem.scss';

/**
 * The LogoNavItem component.
 */
export class LogoNavItem extends React.Component {
  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    const homeLink = buildWordpressUrl();
    const logo = mainConfig.env === 'staging' ? darkblueLogoStaging : darkblueLogo;

    return (
      <div className="navbar-left-logo">
        <a href={homeLink}>
          <img
            className="d-xl-inline-block"
            src={logo}
            alt="Project Content Logo"
          />
        </a>
      </div>
    );
  }
}

export default observer(LogoNavItem);
